import React from "react";
import {
  ComponentToPrint,
  ViewInvoiceContainer,
} from "../features/invoice-view";

export { ComponentToPrint };

export const ViewInvoice = () => <ViewInvoiceContainer />;
